export var TokenType;
(function (TokenType) {
    TokenType["VolleyballBall"] = "VolleyballBall";
    TokenType["VolleyballPlayer"] = "VolleyballPlayer";
    TokenType["BasketballBall"] = "BasketballBall";
    TokenType["BasketballPlayer"] = "BasketballPlayer";
    TokenType["SoccerBall"] = "SoccerBall";
    TokenType["SoccerPlayer"] = "SoccerPlayer";
    TokenType["IceHockeyPuck"] = "IceHockeyPuck";
    TokenType["IceHockeyPlayer"] = "IceHockeyPlayer";
    TokenType["RugbyBall"] = "RugbyBall";
    TokenType["RugbyPlayer"] = "RugbyPlayer";
    TokenType["BaseballBall"] = "BaseballBall";
    TokenType["BaseballPlayer"] = "BaseballPlayer";
    TokenType["CricketBall"] = "CricketBall";
    TokenType["CricketPlayer"] = "CricketPlayer";
    TokenType["CustomPlayer"] = "CustomPlayer";
    TokenType["Cone"] = "Cone";
    TokenType["Flag"] = "Flag";
    TokenType["Hoop"] = "Hoop";
    TokenType["Hurdle"] = "Hurdle";
    TokenType["Pole"] = "Pole";
    TokenType["PlainColor"] = "PlainColor";
})(TokenType || (TokenType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4tdHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zcG9ydHMvdG9rZW4tdHlwZS90b2tlbi10eXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFNBc0JYO0FBdEJELFdBQVksU0FBUztJQUNuQiw4Q0FBaUMsQ0FBQTtJQUNqQyxrREFBcUMsQ0FBQTtJQUNyQyw4Q0FBaUMsQ0FBQTtJQUNqQyxrREFBcUMsQ0FBQTtJQUNyQyxzQ0FBeUIsQ0FBQTtJQUN6QiwwQ0FBNkIsQ0FBQTtJQUM3Qiw0Q0FBK0IsQ0FBQTtJQUMvQixnREFBbUMsQ0FBQTtJQUNuQyxvQ0FBdUIsQ0FBQTtJQUN2Qix3Q0FBMkIsQ0FBQTtJQUMzQiwwQ0FBNkIsQ0FBQTtJQUM3Qiw4Q0FBaUMsQ0FBQTtJQUNqQyx3Q0FBMkIsQ0FBQTtJQUMzQiw0Q0FBK0IsQ0FBQTtJQUMvQiwwQ0FBNkIsQ0FBQTtJQUM3QiwwQkFBYSxDQUFBO0lBQ2IsMEJBQWEsQ0FBQTtJQUNiLDBCQUFhLENBQUE7SUFDYiw4QkFBaUIsQ0FBQTtJQUNqQiwwQkFBYSxDQUFBO0lBQ2Isc0NBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQXRCVyxTQUFTLEtBQVQsU0FBUyxRQXNCcEIifQ==